import AppSettingController from "../../../Main/controller/AppSettingController";
import {useTranslation} from "react-i18next";

export default function ToggleThemeMode() {
    const {t} = useTranslation();
    const setting = AppSettingController.getSetting();

    return (
        <div className={"dark-mode"}>
            <p>{t("setting.toggleDarkMode")}</p>
            <div className={"dark-mode-toggle"}>
                <label className="switch">
                    <input type="checkbox"
                           checked={setting.themeMode === 'dark'}
                           onChange={() => AppSettingController.darkModeToggle()}/>
                    <span className="slider round"></span>
                </label>
            </div>
        </div>
    )
}